import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal} from 'antd'
import { QuestionCircleFilled, DeleteOutlined, DownOutlined, RightOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const {confirm} = Modal

@inject('emailAddressStore')
@observer
class SearchResult extends Component {
  state = {
  }
  componentDidMount() {
  }
  handleDel = (record) => {
    const {emailAddressStore,t,listId} = this.props
    const {searchItem} = emailAddressStore
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        emailAddressStore.onDeleteAddressAction({
          "id": record?.id,
          "listId": listId,
          "marketGroupId": searchItem?.marketGroupId
        })
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {emailAddressStore} = this.props
    emailAddressStore.onChangeDetailsPageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  customExpandIcon = ({ expanded, onExpand, record }) => (
    <span
      onClick={(e) => {
        e.stopPropagation();
        onExpand(record, e);
      }}
      style={{ marginRight: 8, cursor: 'pointer' }}
    >
      {expanded ? <DownOutlined /> : <RightOutlined />}
    </span>
  );
  render() {
    const {emailAddressStore, t} = this.props
    const {pageNoDetails, pageSizeDetails, itemCountDetails, detailsList} = emailAddressStore
    const pagination = getPaginationConfig(pageNoDetails, pageSizeDetails, itemCountDetails, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(detailsList)} pagination={pagination} rowKey="id" style={{padding: 0}} 
          rowClassName={this.getRowClassName}
          expandable={{
            expandIcon: this.customExpandIcon,
            expandedRowRender: (record) => (
              <>
                <div className='tableExpand'>
                  <span className='spanSmall'>姓名</span>
                  <span>{record?.fullName}</span>
                </div>
                <div className='tableExpand'>
                  <span className='spanSmall'>性别</span>
                  <span>{record?.sex==='F' ? '女' : record?.sex==='M' ? '男' : null}</span>
                </div>
                <div className='tableExpand'>
                  <span className='spanSmall'>生日</span>
                  <span>{record?.birthday==='0000-00-00' ? null : record?.birthday}</span>
                </div>
                <div className='tableExpand'>
                  <span className='spanSmall'>手机</span>
                  <span>{record?.phone}</span>
                </div>
                <div className='tableExpand'>
                  <span className='spanSmall'>地区</span>
                  <span>{record?.area}</span>
                </div>
                <div className='tableExpand'>
                  <span className='spanSmall'>添加时间</span>
                  <span>{record?.time}</span>
              </div>
              </>
            ),
            rowExpandable: (record) => record.name !== 'Not Expandable',
          }}
        >
          <Table.Column title={t(`emailSend.emailAddress`)} dataIndex="address" key="address" ellipsis={true} />
          <Table.Column title='变量1' dataIndex="var1" key="var1" ellipsis={true} />
          <Table.Column title='变量2' dataIndex="var2" key="var2" ellipsis={true} />
          <Table.Column title='变量3' dataIndex="var3" key="var3" ellipsis={true} />
          <Table.Column title='变量4' dataIndex="var4" key="var4" ellipsis={true} />
          <Table.Column title='变量5' dataIndex="var5" key="var5" ellipsis={true} />
          <Table.Column title='变量6' dataIndex="var6" key="var6" ellipsis={true} />
          <Table.Column width={200} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
      </>
    )
  }
}

export default withTranslation()(SearchResult)
